import { PageLocatorMap } from '../types/PageLocatorMap';

export const signInPage = {
  alert: {
    error: 'signin.alert.error',
    signupLink: 'signin.alert.signup-link',
  },
  footer: {
    root: 'signin.footer',
  },
  form: {
    h1: 'signin.form.heading1',
    h2: 'signin.form.heading2',
    phoneInput: 'signin.form.phone-input',
    phoneInputError: 'signin.form.phone-error',
    root: 'signin.form.root',
    signupLink: 'signin.form.signup-link',
    submitButton: 'signin.form.submit-button',
  },
  header: {
    root: 'signin.header',
    signupLink: 'signin.header.signup-link',
  },
} as const satisfies PageLocatorMap;
